import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const BurgerIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			{...props}
		>
			<path
				d="M21 8.25H3C2.59 8.25 2.25 7.91 2.25 7.5C2.25 7.09 2.59 6.75 3 6.75H21C21.41 6.75 21.75 7.09 21.75 7.5C21.75 7.91 21.41 8.25 21 8.25Z"
				fill="currentColor"
			/>
			<path
				d="M21 13.25H3C2.59 13.25 2.25 12.91 2.25 12.5C2.25 12.09 2.59 11.75 3 11.75H21C21.41 11.75 21.75 12.09 21.75 12.5C21.75 12.91 21.41 13.25 21 13.25Z"
				fill="currentColor"
			/>
			<path
				d="M21 18.25H3C2.59 18.25 2.25 17.91 2.25 17.5C2.25 17.09 2.59 16.75 3 16.75H21C21.41 16.75 21.75 17.09 21.75 17.5C21.75 17.91 21.41 18.25 21 18.25Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(BurgerIcon);
